module.exports = __webpack_public_path__ + "img/can_play_icon.9fd1eb2f.png";